<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Emojione1stPlaceMedal from "~icons/emojione/1st-place-medal";

const { t } = useI18n();
</script>

<template>
  <span
    v-tooltip="t('components.resource.degree.degreeItem.targetSchool')"
    class="inline-flex shrink-0 items-center"
    role="img"
    :aria-label="t('components.resource.degree.degreeItem.targetSchool')"
  >
    <Emojione1stPlaceMedal class="size-4" aria-hidden="true" />
  </span>
</template>
